import React, { Component } from 'react';
import { session } from '../authentication';
//import RichTextEditor from 'react-rte';
import { ModalFade } from './Modal';
import { config } from '../config';
import { Field, reduxForm} from 'redux-form';//, formValueSelector 
import { Input, TextArea } from './Forms/Input';
import { closeHelp } from '../actions/helpActions';//openHelp, 
import { connect } from 'react-redux';
import { required } from '../validation';//, email
import { alertSuccess, alertDanger } from '../actions/alertActions';
//const DEFAULT_HELP_FORMAT = "html";

let HelpForm = props => {
    //const rte = { format: DEFAULT_HELP_FORMAT };

    const user = props.initialValues;
    var email;
    email = user ? <Field name="id" type="hidden" component="input" value={user.id} /> : <Field name="email" component={Input} type="email" label="Email" validate={[required, email]} />
    const name = user ? null : <Field name="name" component={Input} type="text" label="Name" validate={required} />
    return (<form onSubmit={props.handleSubmit}>
        <Field name="subject" component={Input} type="text" label="Subject"/>
        <Field name="message" component={TextArea} validate={required} label="How can we help?" />
        {name}
        {email}
        <div className="form-group">
            <button className="btn btn-info">Get in touch</button>
        </div>
    </form>)
}

HelpForm = reduxForm({ form: 'HelpForm' })(HelpForm);
HelpForm = connect(state => ({
    initialValues: { id: session.getUser().id, email: '' }
}))(HelpForm);

class Help extends Component {
    constructor(props) {
        super(props);
        this.mailTo = this.mailTo.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    mailTo(message, className) {
        let body = message ? `&body=${message}` : '';
        className = className ? className : '';
        return <a className={className} href={`mailto:${config.supportInbox}?subject=Blaze support${body}`}>{config.supportInbox}</a>
    }
    handleSubmit(form) {
        let errorMessage = <span>Oh no! We couldn't submit your query. Try sending us an email ({this.mailTo(form.message, "alert-link")}).</span>
        //console.log(form);
        fetch(config.apiUrl + '/Support/Contact',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(form)
            }
        ).then(res => {
            //console.log(res);
            if (res.ok) {
                this.props.alertSuccess("Your query has been submitted. We'll be in touch with you shortly");
            }
            else {
                this.props.alertDanger(errorMessage, null);
            }
            this.props.closeHelp();
        });

    }

    render() {
        
        if (this.props.showHelp) {
            return (<ModalFade isOpen={true} className="modal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.props.closeHelp}>&times;</button>
                            <h1>Help and support</h1>
                        </div>
                        <div className="modal-body">
                            <HelpForm onSubmit={this.handleSubmit} />
                        </div>
                        <div className="modal-footer">
                            <div className="text-left">
                                If you prefer, you can send an email to {this.mailTo(null)}. We will always aim to get back to you as soon as possible.
                            </div>

                        </div>
                    </div>
                </div>
            </ModalFade>)
        }
        else {
            return null;
        }

    }
}

const mapStateToProps = (state) => ({
    showHelp: state.help.showHelp
});

export default connect(mapStateToProps, { closeHelp, alertSuccess, alertDanger })(Help);
